<template>
  <Spacer>
    <Title
      v-if="data.title"
      :data="{ value: data.title }"
    />
    <Grid
      :col="gridCol"
      :template="gridTemplate"
    >
      <div
        v-for="(item, index) in data.items"
        :key="index"
        class="item"
      >
        <Content :data="setContent(item)" />
      </div>
    </Grid>
  </Spacer>
</template>

<script>
import { setContent } from '@/assets/js/utils';
import Title from '@/components/typo/title';

import Content from '@/components/blocks/content';

export default {
  name: 'Repeater',
  components: {
    Content,
    Title,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      setContent,
    };
  },
  computed: {
    gridCol() {
      let cols = null;
      if (this.data.layout.length > 0) {
        this.data.layout.forEach((layout) => {
          const { media_query, layout_size } = layout;
          cols = {
            ...cols,
            [media_query]: layout_size === 'auto' ? (12 / this.data.item.length).toString() : layout_size,
          };
        });
      } else {
        cols = {
          xs: 12,
          m: (12 / (this.data.item?.length || this.data.categories?.length || this.data.posts?.length)).toString() || 3,
        };
      }
      return cols;
    },
    gridTemplate() {
      let template = null;
      if (this.data.layout.length > 0) {
        this.data.layout.forEach((layout) => {
          const { media_query, layout_type } = layout;
          template = {
            ...template,
            [media_query]: layout_type,
          };
        });
      } else {
        template = 'default';
      }
      return template;
    },
  },
  methods: {
    content(item) {
      const {
        title, rich_text,
      } = item;

      return {
        title,
        tag_title: 'h2',
        size_title: 'l',
        rich_text,
      };
    },
  },
};
</script>

<style>

</style>
